import type {ReactNode} from 'react';
import React from 'react';

import CSSModules from 'react-css-modules';

import TickBox from '../TickBox';

import styles from './styles.module.scss';

type TickProps = {
  ticksRendered?: boolean[];
  numberOfTicks?: number;
  isPreviewMode?: boolean;
  tickBoxAltText: string;
  getCompletionTicksAriaLabel?: ({
    completedActivitiesCount,
    totalActivitiesCount,
  }: {
    completedActivitiesCount: number;
    totalActivitiesCount: number;
  }) => string;
};

const Tick = ({
  ticksRendered,
  numberOfTicks = 0,
  isPreviewMode,
  tickBoxAltText,
  getCompletionTicksAriaLabel,
}: TickProps): JSX.Element => {
  const ticks: ReactNode[] = [];
  let completedActivitiesCount: number;
  let totalActivitiesCount: number;

  if (!ticksRendered || ticksRendered.length === 0) {
    for (let i = 0; i < numberOfTicks; i++) {
      ticks.push(
        <TickBox
          key={i}
          checked
          isPreviewMode={isPreviewMode}
          altText={tickBoxAltText}
        />
      );
    }
    completedActivitiesCount = numberOfTicks;
    totalActivitiesCount = numberOfTicks;
  } else {
    ticksRendered.map((bool, index) =>
      ticks.push(
        <TickBox
          key={index}
          checked={bool}
          isPreviewMode={isPreviewMode}
          altText={tickBoxAltText}
        />
      )
    );
    completedActivitiesCount = ticksRendered.filter(Boolean).length;
    totalActivitiesCount = ticksRendered.length;
  }

  const ariaLabel = getCompletionTicksAriaLabel
    ? getCompletionTicksAriaLabel({
        completedActivitiesCount,
        totalActivitiesCount,
      })
    : null;

  return (
    <div
      styleName={`ticks ${isPreviewMode ? 'preview-mode' : ''}`}
      {...(ariaLabel ? {'aria-label': ariaLabel} : {})}
    >
      {ticks}
    </div>
  );
};

export default CSSModules(Tick, styles, {allowMultiple: true});
